function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { computed, onServerPrefetch, useRoute, useRouter, useSearchStore } from '#imports';
import { isEqual } from 'lodash';
import { defineStore } from 'pinia';
import { ref, watch } from 'vue';
import { State, interpret } from 'xstate';
import { getHierarchyRepository } from '~/apps/hierarchies/inversify.config';
import { routeToFilters } from '~/apps/pu-links/infrastructure/routeToFilters';
import { getCampsitesWizardMachine } from '~/apps/search-wizard/campsites-search/machine/campsitesWizardMachine';
var isDev = process.env.NODE_ENV !== 'production';
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}
export var useSearchWizardStore = defineStore('searchWizardStore', () => {
  var _window, _window$$nuxt, _window$$nuxt$$pinia$, _window$$nuxt$$pinia$2, _window$$nuxt$$pinia$3;
  var requestID = generateUUID();
  var reqId = ref(requestID);
  var campsitesWizardMachine = getCampsitesWizardMachine();
  var router = useRouter();
  var route = useRoute();
  if (isDev) console.log('useSearchWizardStore created', requestID, route.fullPath);
  var searchStore = useSearchStore(usePinia());
  var lang = route.params.lang || 'en-gb';
  var wizardFilters = ref(campsitesWizardMachine.initialState.context.filters);
  var service = interpret(campsitesWizardMachine.withContext(_objectSpread(_objectSpread({}, campsitesWizardMachine.initialState.context), {}, {
    filters: wizardFilters.value
  })));
  var hierarchy = ref(null);
  var isClearSearch = ref(true);
  var stateStr = ref(process.client && ((_window = window) === null || _window === void 0 ? void 0 : (_window$$nuxt = _window.$nuxt) === null || _window$$nuxt === void 0 ? void 0 : (_window$$nuxt$$pinia$ = _window$$nuxt.$pinia.state) === null || _window$$nuxt$$pinia$ === void 0 ? void 0 : (_window$$nuxt$$pinia$2 = _window$$nuxt$$pinia$.value) === null || _window$$nuxt$$pinia$2 === void 0 ? void 0 : (_window$$nuxt$$pinia$3 = _window$$nuxt$$pinia$2.searchWizardStore) === null || _window$$nuxt$$pinia$3 === void 0 ? void 0 : _window$$nuxt$$pinia$3.stateStr) || '');
  var initialState = stateStr.value ? JSON.parse(stateStr.value) : service.initialState;
  var state = State.create(initialState);
  var context = ref(state.context);
  var states = ref(state.toStrings());
  var isSearchWizardOpen = ref(null);
  var openOnFocus = ref(false);
  var panelOpen = ref(false);
  service.onTransition((newState, event) => {
    if (isDev) console.log('useSearchWizard.onTransition', requestID, route.fullPath, newState.toStrings(), event.type);
    if (process.server) stateStr.value = JSON.stringify(newState);
    state = newState;
    states.value = newState.toStrings();
    context.value = newState.context;
    wizardFilters.value = searchStore.filterCountsFilter(newState.context.filters);
  }).start(state);
  if (process.server) {
    onServerPrefetch( /*#__PURE__*/_asyncToGenerator(function* () {
      if (isDev) console.log('useSearchWizardStore.onServerPrefetch', requestID, route.fullPath);
      var serverRoute = route;
      if (serverRoute.fullPath != route.fullPath) {
        throw new Error("useSearchWizardStore PATH MISMATCH: ".concat(serverRoute.fullPath, " != ").concat(route.fullPath));
      }
      var serverFilters = routeToFilters(serverRoute);
      yield setWizardFilters(serverFilters);
      if (isDev) console.log('useSearchWizardStore.onServerPrefetch finished', requestID, route.fullPath);
      // see if stopping the service cleans it up
      service.stop();
    }));
  }
  if (process.client) {
    // when navigating to searchedit pages, set wizard open
    router.beforeEach((to, _from, next) => {
      var _to$name;
      if ((_to$name = to.name) !== null && _to$name !== void 0 && _to$name.startsWith('searchedit')) {
        isSearchWizardOpen.value = true;
      }
      openOnFocus.value = Boolean(to.name === 'homepage');
      next();
    });

    // when a new route is done, use that for the wizard filters
    watch(() => searchStore.filterCountsFilter(routeToFilters(route)), /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (filters) {
        if (isDev) console.log('useSearchWizardStore.filtersChanged', filters);
        yield setFilters(filters);
      });
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    // Add a watch effect for panelOpen to trigger updateCounts when the panel is opened
    watch(panelOpen, /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(function* (newVal) {
        if (newVal === true) {
          yield updateCounts();
        }
      });
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
  }
  function fetchHierarchyData(_x3) {
    return _fetchHierarchyData.apply(this, arguments);
  }
  function _fetchHierarchyData() {
    _fetchHierarchyData = _asyncToGenerator(function* (newHierarchyPath) {
      if (newHierarchyPath) {
        var _hierarchy$value;
        if (((_hierarchy$value = hierarchy.value) === null || _hierarchy$value === void 0 ? void 0 : _hierarchy$value.path) !== newHierarchyPath) {
          var repository = getHierarchyRepository();
          var hierarchyData = yield repository.readOneByPath(newHierarchyPath, lang);
          hierarchy.value = hierarchyData;
        }
        service.send('SET_LOCATION', {
          data: _objectSpread({
            dataType: 'hierarchy'
          }, hierarchy.value)
        });
      } else {
        hierarchy.value = null;
      }
    });
    return _fetchHierarchyData.apply(this, arguments);
  }
  var isSearchEnabled = computed(() => {
    var ctx = context.value;
    if (!ctx) {
      return false;
    }
    var hasSelectedLocation = !!ctx.selectedLocation;
    var hasSelectedGeo = !!ctx.filters.area && !ctx.filters.area.isEmptyPoint;
    var hasBounds = !!ctx.filters.bounds;
    var isSeoFacetUrl = route.fullPath.includes('/-/');
    return hasSelectedLocation || hasSelectedGeo || hasBounds || isSeoFacetUrl;
  });
  var searchButtonFilters = computed(() => {
    var filters = wizardFilters.value;
    var area = filters.area;
    var isInitialCityLevel = area && !area.isEmptyPoint && filters.hierarchyPath;
    if (isInitialCityLevel && area) {
      area.isEmptyPoint = true;
    }
    return _objectSpread(_objectSpread({}, filters), {}, {
      area
    });
  });
  function setFilters(_x4) {
    return _setFilters.apply(this, arguments);
  }
  function _setFilters() {
    _setFilters = _asyncToGenerator(function* (filters) {
      filters = searchStore.filterCountsFilter(filters);
      if (filters && !isEqual(wizardFilters.value, filters)) {
        var _context$value7, _context$value8, _context$value8$selec;
        service.send({
          type: 'SET_FILTERS',
          filters
        });
        // do not fetch campsite data
        if (filters.hierarchyPath && (!(context !== null && context !== void 0 && (_context$value7 = context.value) !== null && _context$value7 !== void 0 && _context$value7.selectedLocation) || (context === null || context === void 0 ? void 0 : (_context$value8 = context.value) === null || _context$value8 === void 0 ? void 0 : (_context$value8$selec = _context$value8.selectedLocation) === null || _context$value8$selec === void 0 ? void 0 : _context$value8$selec.dataType) === 'hierarchy')) {
          yield fetchHierarchyData(filters.hierarchyPath);
        } else {
          hierarchy.value = null;
        }
      }
      return yield Promise.resolve(true);
    });
    return _setFilters.apply(this, arguments);
  }
  function setWizardFilters(_x5) {
    return _setWizardFilters.apply(this, arguments);
  }
  function _setWizardFilters() {
    _setWizardFilters = _asyncToGenerator(function* (filters) {
      yield setFilters(filters);
      if (process.client) yield nextTick();
      yield updateCounts();
      return yield Promise.resolve(true);
    });
    return _setWizardFilters.apply(this, arguments);
  }
  var inputPlaceholder = computed(() => {
    var _context$value, _context$value$search, _context$value2;
    var searchType = context === null || context === void 0 ? void 0 : (_context$value = context.value) === null || _context$value === void 0 ? void 0 : (_context$value$search = _context$value.searchInputValue) === null || _context$value$search === void 0 ? void 0 : _context$value$search.type;
    var selectedLocation = context === null || context === void 0 ? void 0 : (_context$value2 = context.value) === null || _context$value2 === void 0 ? void 0 : _context$value2.selectedLocation;
    if (myLocationPoint.value) {
      return 'Around current location...';
    } else if (searchType === 'BOUNDS') {
      return 'Custom map area';
    } else if (selectedLocation !== null && selectedLocation !== void 0 && selectedLocation.name) {
      return selectedLocation.name;
    } else {
      return 'Where are you going?';
    }
  });
  var totalCounts = computed(() => {
    var _searchStore$searchCo, _searchStore$searchCo2;
    return ((_searchStore$searchCo = searchStore.searchCounts) === null || _searchStore$searchCo === void 0 ? void 0 : _searchStore$searchCo.bookableCount) || ((_searchStore$searchCo2 = searchStore.searchCounts) === null || _searchStore$searchCo2 === void 0 ? void 0 : _searchStore$searchCo2.count);
  });
  var counts = computed(() => {
    return searchStore.searchCounts;
  });
  var myLocationPoint = computed(() => {
    var _context$value$filter, _context$value$filter2;
    if ((_context$value$filter = context.value.filters.area) !== null && _context$value$filter !== void 0 && _context$value$filter.lat && (_context$value$filter2 = context.value.filters.area) !== null && _context$value$filter2 !== void 0 && _context$value$filter2.lng && !context.value.filters.placename) {
      return context.value.filters.area;
    }
    return undefined;
  });
  var isHierarchyPoint = computed(() => {
    var _context$value3;
    var selectedLocation = context === null || context === void 0 ? void 0 : (_context$value3 = context.value) === null || _context$value3 === void 0 ? void 0 : _context$value3.selectedLocation;
    return Boolean(selectedLocation && selectedLocation.dataType === 'hierarchy' && selectedLocation.type === 3);
  });
  var selectedHierarchyName = computed(() => {
    var _context$value4;
    var selectedLocation = context === null || context === void 0 ? void 0 : (_context$value4 = context.value) === null || _context$value4 === void 0 ? void 0 : _context$value4.selectedLocation;
    return (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.name) || '';
  });
  var shouldShowWithinInput = computed(() => {
    var _context$value5;
    var point = (_context$value5 = context.value) === null || _context$value5 === void 0 ? void 0 : _context$value5.filters.area;
    return isHierarchyPoint.value || Boolean(point);
  });
  var showCount = computed(() => {
    var _context$value6;
    var selectedLocation = context === null || context === void 0 ? void 0 : (_context$value6 = context.value) === null || _context$value6 === void 0 ? void 0 : _context$value6.selectedLocation;
    var isCampsite = (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.dataType) === 'campsite';
    return Boolean(!isCampsite && isSearchEnabled.value && totalCounts.value);
  });
  function updateCounts() {
    return _updateCounts.apply(this, arguments);
  }
  function _updateCounts() {
    _updateCounts = _asyncToGenerator(function* () {
      var _context$value9;
      if (process.client) yield nextTick();
      var selectedLocation = context === null || context === void 0 ? void 0 : (_context$value9 = context.value) === null || _context$value9 === void 0 ? void 0 : _context$value9.selectedLocation;
      var isCampsite = (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.dataType) === 'campsite';
      // only update counts if we are showing counts
      if (isSearchEnabled.value && !isCampsite) {
        return yield searchStore.countsSearch(wizardFilters.value);
      }
      return yield Promise.resolve(false);
    });
    return _updateCounts.apply(this, arguments);
  }
  var within = computed(() => {
    // use the within from the filters or the backend within
    return context.value.filters.within || searchStore.localizedWithin;
  });
  return {
    context,
    hierarchy,
    send: service.send,
    states,
    inputPlaceholder,
    isSearchEnabled,
    searchButtonFilters,
    isClearSearch,
    wizardFilters,
    setWizardFilters,
    stateStr,
    totalCounts,
    updateCounts,
    counts,
    myLocationPoint,
    shouldShowWithinInput,
    showCount,
    isSearchWizardOpen,
    openOnFocus,
    selectedHierarchyName,
    reqId,
    panelOpen,
    within
  };
});